import React, { useState, useEffect, Fragment } from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate } from 'react-router-dom'
//import CsietList from "./NewForeignEList";
import {foreignexchangelists, api} from '../../../apis/urls'
import axios from "axios";
import Loader from '../../../common-components/loader'
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";

const GisaApprove = () => {

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Gisalist();
            });
    }, []);

    const [loader,setLoader] = useState(false);
    const [type, setType] = useState('GISA');
    const [result,setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);

    let counts = 0;
    if(result)
    {
        counts = result.length;
    }

    let navigate = useNavigate();

    const DeleteGisapro = (id) => {
        let r = window.confirm("Are you sure you want to delete this Program?");

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: foreignexchangelists+'/'+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                Gisalist();
                navigate("/gisapprovelist")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    }

    const DeleteCsiet = (id) => {
        let r = window.confirm("Are you sure you want to delete this Program?");

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: foreignexchangelists+'/'+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                Gisalist();
                navigate("/gisapprovelist")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    }

    
    



    const Gisalist = () => {


        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: foreignexchangelists,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            


            if(response.data.message === "Success"){            
                setResult(response.data.data.items);
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
            }else{
                setResult(false)
            }

            setLoader(false)

            //console.log(responseponse.data.data)

            let path = 'newPath'; 
            navigate("/gisapprovelist")
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });        
    }


    

    const refreshList = () => {
        setResult(null);
      };



      let token = "Bearer "+localStorage.getItem('token');
      const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
      });

    const findByTitles = name => {
        return instances.get(`foreignexchanges?search=${name}`);
      };

      const onChangeSearchTitle = (e) => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);
        findByTitles(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setResult(response.data.data.items)
            }else{
                setResult(false)
            }
          })
          .catch(e => {
            console.log(e);
          });
      };


      const findByTitlesss = option => {
        return instances.get(`foreignexchanges?status=${option}`);
      };

      const onChangeSearchTitles = (e) => {
        const searchTitle = e.target.value;
        findByTitlesss(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setResult(response.data.data.items)
            }else{
                setResult(false)
            }
            //console.log(response.data.data);
          })
          .catch(e => {
            console.log(e);
          });
      };

    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     const instance = axios.create({
         baseURL: foreignexchangelists+'?page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

         setResult(res.data.data.items)
  
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });

 };


    let sl = 1;
    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    


               

                    <div class="page-title-wrpr">
                            <div class="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                                <h2 className="page-title">Foreign Exchage</h2>
                            </div>

                            <div class="page-rightside-action-column">
                                <div class="input-groups mt-3 mb-3 search-grp">
                                <div class="input-group-prepends">
                                <select class="form-controls custom-select" onChange={onChangeSearchTitles}>
                                    <option value="none" selected disabled hidden>STATUS</option>
                                    <option value=" ">ALL</option>
                                    <option>ACTIVE</option>
                                    <option>INACTIVE</option>
                                    <option>DELETE</option>
                                    </select> 
                                </div>
                                <input type="text" 
                                class="form-controls search-bar"             
                                value={searchTitle}
                                onChange={onChangeSearchTitle}
                                placeholder="Search" />
                                <button  class="btn btn-search icon-search"></button>
                                </div>
                                <Link to="/add_gissaforeign" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Foreign"><i class="icon-add"></i><span>Add New Foreign Exchage</span> </Link>
                            </div>


                        </div>

                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li class="breadcrumb-item active" aria-current="page">Gisa Approved International Program</li>
                        </ol>
                    </nav>
                {result?
                    <div class="number-of">
                        Displaying 1-{counts} of {totalItems} results.
                    </div>:null
                }
                                                
                    <div className="jobs-list-wrpr list-wrpr">
                        {result?
                            (result?.map((item,index) =>
                                <div className="list" key={item.id}>
                                    <div className="row">

                                        <div className="col-md-2">
                                        <div class="jobs-user">
                                            Sl.No
                                            <span class="desig">{sl++}</span>
                                        </div>
                                        </div>

                                        
                                        <div className="col-md-4">
                                            <div className="jobs-user">
                                                Name
                                                <span class="desig"> {item.name}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                                Type
                                                <span class="desig"> {item.type} </span>    
                                            </div>
                                        </div>
                                        

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                                Status
                                                <span class="desig"> {item.status}</span>
                                            </div>
                                        </div> 

                     

                  {/* gisa edit button */}

                                    <div className="col-md-2">
                                        <div className="list-action-wrpr text-right roundicons-text">       
                                            {item.type === 'GISA' ? 
                                            <div>
                                                <Link  to={"/edit_gissaforeign/"+item.id} data-toggle="tooltip" title="Edit"><i className="edit icon-pencil3" ></i><span>Update</span></Link>
                                                <button data-toggle="tooltip" title="Delete" onClick={ () => { DeleteGisapro(item.id)} } style={{backgroundColor:'#fff'}}><a><i className="delete icon-close1"></i><span>Delete</span></a></button>
                                            </div>:
                                            <div>
                                                <Link  to={"/edit_csiet/"+item.id} data-toggle="tooltip" title="Edit"><i className="edit icon-pencil3" ></i><span>Update</span></Link>
                                                <button data-toggle="tooltip" title="Delete" onClick={()=> { DeleteCsiet(item.id) }}  style={{backgroundColor:'#fff'}}><a><i className="delete icon-close1"></i><span>Delete</span></a></button>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                </div>                     
                                )):null 
                            }
                            {
                            !result?
                                (<div className="nodata">
                                    <h2>Sorry! No Result Found</h2>
                                </div>):null
                            }
                            {result?
                                <div class="number-of footer-number">
					                Displaying 1-{counts} of {totalItems} results.
				                </div>:null
                            }
                            </div> 
                            { 
                                loader?
                                <div>
                                    <div className="loader_container"><Loader/></div>
                                </div>
                                :
                                null
                            }  

                            {result?
                                <div class="pagination-wrpr">
                                    <ReactPaginate
                                        className="pagination page"
                                        pageClassName="page-item"
                                        activeClassName="active"
                                        nextLabel=">"
                                        previousLabel="<"
                                        previousClassName="page-link p-link"
                                        nextClassName="page-link p-link"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={10}
                                        pageCount={totalPages}
                                        renderOnZeroPageCount={1}
                                        />
                                </div>:null
                            }


      
                    </div>
            </aside>
        </div>
    );
}

export default GisaApprove;
